export const goshopsDocMenu = [
  {
    name: "Introduction",
    dropDownItems: [
      {
        name: "Introduction",
        routerPath: "/goshops-documentation",
      },
      {
        name: "Server requirements",
        routerPath: "/goshops-documentation/recommendations",
      },
    ],
  },
  {
    name: "Backend Api",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/goshops-documentation/server",
      },
      {
        name: "Installation",
        routerPath: "/goshops-documentation/mandatory-setup-backend",
      },
      {
        name: "Troubleshooting",
        routerPath: "/goshops-documentation/troubleshooting-backend",
      },
    ],
  },
  {
    name: "Admin Panel",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/goshops-documentation/admin",
      },
      {
        name: "Installation",
        routerPath: "/goshops-documentation/install-on-server",
      },
      {
        name: "Troubleshooting",
        routerPath: "/goshops-documentation/troubleshooting-admin",
      },
    ],
  },
  {
    name: "Customer Website",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/goshops-documentation/front",
      },
      {
        name: "Installation",
        routerPath: "/goshops-documentation/mandatory-setup-web",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Customer App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/goshops-documentation/mobile-app",
      },
      {
        name: "Installation",
        routerPath: "/goshops-documentation/mandatory-setup-customer",
      },
      {
        name: "Customization",
        routerPath: "/goshops-documentation/customization-customer",
      },
      {
        name: "App build & release",
        routerPath: "/goshops-documentation/customer-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Vendor App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/goshops-documentation/vendor-app",
      },
      {
        name: "Installation",
        routerPath: "/goshops-documentation/mandatory-setup-vendor",
      },
      {
        name: "Customization",
        routerPath: "/goshops-documentation/customization-vendor",
      },
      {
        name: "App build & release",
        routerPath: "/goshops-documentation/vendor-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Driver App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/goshops-documentation/driver-app",
      },
      {
        name: "Installation",
        routerPath: "/goshops-documentation/mandatory-setup-deliveryboy",
      },
      {
        name: "Customization",
        routerPath: "/goshops-documentation/customization-deliveryboy",
      },
      {
        name: "App build & release",
        routerPath: "/goshops-documentation/deliveryboy-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Pos App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/goshops-documentation/pos-app",
      },
      {
        name: "Installation",
        routerPath: "/goshops-documentation/mandatory-setup-pos",
      },
      {
        name: "Customization",
        routerPath: "/goshops-documentation/customization-pos",
      },
      {
        name: "App build & release",
        routerPath: "/goshops-documentation/pos-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Firebase setup",
    routerPath: "/goshops-documentation/firebase",
  },
  {
    name: "Update",
    routerPath: "/goshops-documentation/update",
  },
];
